export default function Features() {
  return (
    <section id="features" className="py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-serif text-[#3A2817] max-w-3xl mx-auto leading-tight">
            What Makes Us Different
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="bg-[#0D0D0D] rounded-3xl p-8 h-96 relative overflow-hidden group hover:scale-105 transition-transform duration-300">
            <div className="absolute top-8 left-8 w-14 h-14 bg-[#2A2A2A] rounded-full flex items-center justify-center">
              <i className="ri-apple-fill text-white text-2xl"></i>
            </div>
            <div className="relative z-10 mt-24">
              <h3 className="text-3xl font-bold text-white mb-4 leading-tight">
                Native iOS Development
              </h3>
              <p className="text-base text-[#9A9A9A] leading-relaxed">
                Built specifically for Apple ecosystem with Swift and SwiftUI, ensuring optimal performance and seamless integration
              </p>
            </div>
          </div>

          <div className="rounded-3xl h-96 relative overflow-hidden group hover:scale-105 transition-transform duration-300">
            <img
              src="https://public.readdy.ai/ai/img_res/06a65b2bb0cdd8eeb06bf378f5f05e51.jpg"
              alt="Security Feature"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/70"></div>
            <div className="absolute top-8 left-8">
              <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-sm px-4 py-2 rounded-full">
                <i className="ri-shield-check-fill text-white text-lg"></i>
                <span className="text-white text-sm font-semibold uppercase tracking-wide">SECURITY</span>
              </div>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <h3 className="text-3xl font-bold text-white drop-shadow-lg">
                Advanced Protection
              </h3>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 h-96 relative overflow-hidden shadow-lg group hover:scale-105 transition-transform duration-300">
            <div className="mb-6">
              <h3 className="text-3xl font-serif text-[#3A2817] leading-tight mb-4">
                User-Centric Design
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                Intuitive interfaces crafted for seamless user experience with attention to every detail
              </p>
            </div>
            <div className="mt-12">
              <div className="w-full h-52 bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl overflow-hidden shadow-md">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20iOS%20app%20interface%20mockup%20showing%20elegant%20user-centric%20design%20with%20intuitive%20navigation%20and%20beautiful%20typography%2C%20modern%20mobile%20UI%20with%20teal%20accent%20colors%20and%20white%20background%2C%20professional%20app%20screen%20displaying%20smooth%20user%20experience%20and%20minimalist%20layout%2C%20high%20quality%20interface%20design%20photography&width=400&height=250&seq=feature-design-001&orientation=landscape"
                  alt="User Design"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-32 text-center">
          <div className="max-w-4xl mx-auto mb-12">
            <div className="w-full h-96 bg-gray-100 rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20office%20environment%20with%20iOS%20developers%20collaborating%20on%20MacBooks%20and%20iPhones%2C%20bright%20professional%20workspace%20with%20large%20windows%20and%20natural%20lighting%2C%20team%20working%20on%20mobile%20app%20development%20with%20devices%20and%20screens%20visible%2C%20contemporary%20tech%20company%20atmosphere%20with%20teal%20and%20white%20design%20elements%2C%20high%20quality%20corporate%20photography&width=1200&height=600&seq=cta-office-001&orientation=landscape"
                alt="Office Environment"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="max-w-3xl mx-auto">
            <h3 className="text-4xl leading-relaxed mb-2">
              <span className="text-[#2D2D2D] font-normal">Ready to transform</span>
            </h3>
            <h3 className="text-4xl leading-relaxed mb-2">
              <span className="text-[#6B6B6B] font-serif italic">your mobile experience</span>
            </h3>
            <h3 className="text-4xl leading-relaxed">
              <span className="text-[#2D2D2D] font-bold">with premium iOS apps?</span>
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}
